import React, { useState, useRef } from 'react';
import dataTableSettings from '../TrialUI/dataTableSettings';
import DataTable from '../DataTable';
import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import { UserContext } from '../../Context/UserContext';
import { InstanceContext } from '../../InstanceContext';
import trialSettings from './userManagementSetting';
import { trackError } from '../../utils/activityTracker'

const UserManagement = (props) => {
  const { user, userAction } = React.useContext(UserContext);
  const { contextInstance } = React.useContext(InstanceContext);
  const [userData, setUserData] = useState([]);
  const [customMemo, setCustomMemo] = React.useState(0)
  const tabSettings = trialSettings.tabs.users;
  const trialInstance = contextInstance || user.instance;
  let mounted = useRef(false);

  const getUserDetails = () => {
    mounted.current = true;
    setUserData([]);
    // removed 'axiosConfig.auth' as token is updated on login
    axios.get(`${axiosConfig.apiUrl}/rt/console/allPIUsers/${trialInstance}/${user.email}`)
    .then(response => {
      setUserData(response.data);
      setCustomMemo(customMemo + 1)
    }).catch(error => {
      console.log('error', error);
      trackError({ error: error, history: props.history })
        if (error.response.status === 403) {
          userAction({type: 'logout'})
        }
    });
  }

  if (!mounted.current) getUserDetails();

  return (
    <DataTable
      {...props}
      settings={dataTableSettings}
      // headerSettings={dataTableSettings}
      history={props.history}
      location={props.location}
      tabSettings={tabSettings}
      headers={tabSettings.headers}
      data={userData}
      dropdown={tabSettings.dropdown}
      userDetails={getUserDetails}
      options={{
        customTopOffset: 45,
        offsetWidth: 175
      }}
      memo={customMemo}
    />
  )
}

export default UserManagement;
